import { render, staticRenderFns } from "./TopOffer.vue?vue&type=template&id=234abb79&"
import script from "./TopOffer.vue?vue&type=script&lang=js&"
export * from "./TopOffer.vue?vue&type=script&lang=js&"
import style0 from "./TopOffer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports